"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  days: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
  daysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  daysMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  today: 'Vandaag',
  clear: 'Legen',
  dateFormat: 'dd-MM-yyyy',
  timeFormat: 'HH:mm',
  firstDay: 0
};
exports.default = _default;